import './NoticeToast.css';

export default function NoticeToast({ notice, onClose }) {
  if (!notice?.message) {
    return null;
  }

  const typeClass = notice.type ? `notice-${notice.type}` : 'notice-info';

  return (
    <div className={`notice-toast ${typeClass}`} role="status" aria-live="polite">
      <span>{notice.message}</span>
      <button type="button" onClick={onClose} aria-label="Fermer la notification">
        x
      </button>
    </div>
  );
}
